import Control from './Select';
import Option from './Option';

export { Control as Select };
export { Option };

const controls = { Control, Option };
export default controls;


// WEBPACK FOOTER //
// ./src/components/form/select/index.js